const options = {
  5: "bg-rose-800/5",
  10: "bg-rose-800/10",
  25: "bg-rose-800/25",
  50: "bg-rose-800/50",
  75: "bg-rose-800/75",
  90: "bg-rose-800/90",
  100: "bg-rose-800",
};

const from = {
  5: "from-rose-800/5",
  10: "from-rose-800/10",
  25: "from-rose-800/25",
  50: "from-rose-800/50",
  75: "from-rose-800/75",
  90: "from-rose-800/90",
  100: "from-rose-800",
};

export default function getBackgroundRose800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
